module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCondLight-Italic.0194634b.ttf";